/**
 * UserInfoSection Component
 * 사용자 등록 정보 표시 섹션 (수정 모드 전용)
 */
import React from 'react';
import { User } from '../types/user.types';
import { INFO_LABELS, displayValue } from './userDetailModal.helpers';

// ======== 타입 ========

interface UserInfoSectionProps {
    user: User;
}

// ======== 컴포넌트 ========

const UserInfoSection: React.FC<UserInfoSectionProps> = ({ user }) => {
    return (
        <div className="info-section">
            <h3 className="section-title">{INFO_LABELS.SECTION_TITLE}</h3>
            <div className="info-grid">
                <div className="info-row">
                    <span className="info-label">{INFO_LABELS.INS_USER}</span>
                    <span className="info-value">{user.insUser}</span>
                </div>
                <div className="info-row">
                    <span className="info-label">{INFO_LABELS.INS_DATE}</span>
                    <span className="info-value">{user.insDate}</span>
                </div>
                <div className="info-row">
                    <span className="info-label">{INFO_LABELS.UPD_USER}</span>
                    <span className="info-value">{displayValue(user.updUser)}</span>
                </div>
                <div className="info-row">
                    <span className="info-label">{INFO_LABELS.UPD_DATE}</span>
                    <span className="info-value">{displayValue(user.updDate)}</span>
                </div>
            </div>
        </div>
    );
};

export default UserInfoSection;
